import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ClipboardService {
	public copyToClipboard(content: string) {
		if (window.isSecureContext && navigator.clipboard) {
			return navigator.clipboard.writeText(content);
		} else {
			return this.unsecuredCopyToClipboard(content);
		}
	}

	private unsecuredCopyToClipboard(text) {
		return new Promise<void>((resolve, reject) => {
			const textArea = document.createElement("textarea");
			textArea.value = text;
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			try {
				document.execCommand('copy');
				document.body.removeChild(textArea);
				resolve();
			} catch (err) {
				console.error('Unable to copy to clipboard', err);
				document.body.removeChild(textArea);
				reject(err);
			}
		})
	}
}